import routeSVG from '../../assets/icons/route.svg';
import { CoreIcon } from '../core-icon';

import type { IconProps } from '../core-icon';

export const RouteIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={routeSVG} {...props} />;
};
